import { Component, OnDestroy } from '@angular/core';
import { NavController, AlertController, ToastController, ViewController, LoadingController, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Geolocation } from '@ionic-native/geolocation';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../providers/customizer/customizer';

@Component({
  selector: 'page-selectshop',
  templateUrl: 'selectshop.html'
})
export class SelectShopPage implements OnDestroy {
  searchText: string = '';
  items;
  selected = false;
  loading: any = this.loadingCtrl.create({
    content: '<ion-spinner name="circles"></ion-spinner>'
  });
  url: string;
  results;
  shops = [];
  noShop = false;
  selection: string;
  slots = [];
  private _onDestroy = new Subject();

  constructor(public navCtrl: NavController,
    public translateService: TranslateService,
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public provider: provider,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    public geolocation: Geolocation,
    public platform: Platform,
    public http: HttpClient,
    public customizer: CustomizerProvider) {

    this.url = provider.getUrl() + '/';
    this.items = JSON.parse(sessionStorage.getItem('comuni'));

    const loading = this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'
    });

    loading.present().then(() => {
      //Start geolocation
      this.geolocation.getCurrentPosition({ timeout: 5000, enableHighAccuracy: true }).then((resp) => {
        // resp.coords.latitude
        // resp.coords.longitude
        this.provider.getNearCountry(resp.coords.latitude, resp.coords.longitude).takeUntil(this._onDestroy).subscribe((response) => {
          loading.dismiss();
          var countries = JSON.parse((<any>response)._body);
          if (countries != null && countries.length > 0) {
            this.selection = countries[0].comune;
            this.results = this.items.filter((item) => {
              return (item.name).toLowerCase().startsWith(this.selection.toLowerCase());
            })
          }
        }, (error) => {
          loading.dismiss();
          console.log('Error getting location', error);
        })
      }).catch((error) => {
        loading.dismiss();
        console.log('Error getting location', error);
      });
    });

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  initializeItems() {
    return this.items;
  }

  onInput(ev: any) {
    this.initializeItems();
    const val = ev.target.value;
    this.noShop = false;
    this.selected = false;
    this.shops = [];
    if (val && val.trim() != '') {
      this.results = this.items.filter((item) => {
        return (item.name).toLowerCase().startsWith(val.toLowerCase());
      })
    }
  }

  onCancel(ev: any) {
    this.initializeItems();
    this.noShop = false;
    this.selected = false;
    this.shops = [];
  }

  select(item) {
    this.selected = true;
    this.provider.getShops(item.code).takeUntil(this._onDestroy).subscribe(shops => {
      this.shops = JSON.parse((<any>shops)._body);
    }, err => {
      this.noShop = true;
    });
  }

  selectShop(shop) {
    if (shop.bundleId != null && shop.bundleId != '') {
      this.translateService.get(['CUSTOM_APP_TITLE', 'CUSTOM_APP_REDIRECT']).takeUntil(this._onDestroy).subscribe(messages => {
        this.provider.getStoreUrl(shop.bundleId).then(url => {
          let alert = this.alertCtrl.create({
            title: messages.CUSTOM_APP_TITLE,
            message: messages.CUSTOM_APP_REDIRECT,
            buttons: [
              {
                text: 'OK',
                role: 'cancel',
                handler: () => {
                  // Open custom url
                  window.open(url, "_system");
                }
              }
            ]
          });
          alert.present();
        });
      });
    }
    else {
      // ok, return customer code
      this.viewCtrl.dismiss(shop.customercode);
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/selectshop/selectshop.ts